import { render } from "./DocumentBlock.vue?vue&type=template&id=462faf44&scoped=true"
import script from "./DocumentBlock.vue?vue&type=script&lang=js"
export * from "./DocumentBlock.vue?vue&type=script&lang=js"

import "./DocumentBlock.vue?vue&type=style&index=0&id=462faf44&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-462faf44"]])

export default __exports__